// PersonRasterZone — French. The console's language; the record's own content is French too, but
// the two are separate things. 'not collected', 'Loading…', 'held', 'open' and 'none' live in
// common.fr.ts. The evidence words, 'estimated', 'confidence', 'yes'/'no' and the two ProfileZone
// sentences this zone shares ARE declared below, byte-identical to ProfileZone.fr.ts: this zone
// must read French on its own, and an identical duplicate never warns.
//
// The raster's own block, cell and token names are declared beside their value in
// `src/shared/person-raster.v1.ts` and read through `personLabelFor` — never retyped here.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Profile': 'Profil',
  'Fill': 'Remplir',
  'Queuing…': 'Mise en file…',
  '{n} comparable cells · {p} a fill may propose · raster {v}':
    '{n} cellules comparables · {p} qu’une passe peut proposer · grille {v}',
  'computed': 'calculé',
  'not yet computed': 'pas encore calculé',
  'The night job has not computed this person yet; every computed cell reads "not collected" until it does.':
    'Le travail de nuit n’a pas encore calculé cette personne ; chaque cellule calculée se lit comme non collectée jusque-là.',
  'five blocks of comparable cells — what the record can say about a person, and how it came to say it':
    'cinq blocs de cellules comparables — ce que le dossier peut dire d’une personne, et comment il en est venu à le dire',
  'Send an agent to fill this raster: the employer’s own pages, the registers, your own correspondence — never LinkedIn. Every value arrives with its verbatim quote; what the rule can hold is held on arrival, the rest waits in Review.':
    'Envoyer un agent remplir cette grille : les pages propres de l’employeur, les registres, votre propre correspondance — jamais LinkedIn. Chaque valeur arrive avec sa citation verbatim ; ce que la règle peut retenir est retenu à l’arrivée, le reste attend en Revue.',

  // the states of the zone
  'The raster did not answer': 'La grille n’a pas répondu',
  'No cell of the raster is filled for this person. "Fill" starts a run; every value it reads comes back with its verbatim quote — a professional cell the rule can verify is held on arrival, everything about the person themselves waits for your click.':
    'Aucune cellule de la grille n’est renseignée pour cette personne. « Remplir » lance une passe ; chaque valeur lue revient avec sa citation verbatim — une cellule professionnelle que la règle peut vérifier est retenue à l’arrivée, tout ce qui touche la personne elle-même attend votre clic.',
  'computed nightly · no claim mark': 'calculé chaque nuit · sans marque de revendication',

  // the coverage figures
  'held · estimated · computed · open — counted over the comparable cells asked of this person; a verdict and a cell that does not apply are counted apart':
    'retenu · estimé · calculé · ouvert — comptés sur les cellules comparables posées à cette personne ; un verdict et une cellule sans objet sont comptés à part',
  'estimated': 'estimé',

  // the states of a cell
  'not found': 'introuvable',
  'A run searched for this cell and found nothing; later runs leave it alone unless asked to refresh.': 'Une passe a cherché cette cellule et n’a rien trouvé ; les passes suivantes la laissent, sauf demande de rafraîchissement.',
  'not applicable': 'sans objet',
  'This cell is not asked of this person: the condition it hangs on — a register row, a rank, a held function — does not hold.':
    'Cette cellule n’est pas posée à cette personne : la condition dont elle dépend — une inscription au registre, un rang, une fonction retenue — n’est pas remplie.',
  '{n} proposal in Review': '{n} proposition en Revue',
  '{n} proposals in Review': '{n} propositions en Revue',
  'A proposal on this cell waits in Review; nothing is on the record until it is held.':
    'Une proposition sur cette cellule attend en Revue ; rien n’est au dossier tant qu’elle n’est pas retenue.',
  'The agent inferred this value; it was not read off a page.':
    'L’agent a inféré cette valeur ; elle n’a pas été lue sur une page.',
  'confidence': 'confiance',
  'read': 'lecture',
  'declared': 'déclaré',
  'yes': 'oui',
  'no': 'non',

  // the evidence
  'evidence': 'preuve',
  'hide evidence': 'masquer la preuve',
  'Show the verbatim evidence for this cell': 'Afficher la preuve verbatim de cette cellule',
  'The evidence names a source but keeps no verbatim passage.':
    'La preuve nomme une source mais ne conserve aucun passage verbatim.',
}, 'PersonRasterZone');
